/**
 * creative web のルートコンポーネント
 *
 * @graph-stack creative
 * @graph-domain Marketing
 * @graph-business creative web のルートコンポーネント。TanStack Query・Router・Toast のプロバイダを束ねる。
 * @graph-connects none
 */
import { ToastProvider } from '@cortex/web-design-system/components/ui/Toast';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { type JSX } from 'react';
import { router } from './router.js';

/** アプリ全体で共有する TanStack Query クライアント。 */
/** @graph-connects none */
const queryClient = new QueryClient();

/**
 * アプリケーションのルートコンポーネント。
 * @returns ルート要素
 * @graph-connects none
 */
export function App(): JSX.Element {
  return (
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <RouterProvider router={router} />
      </ToastProvider>
    </QueryClientProvider>
  );
}
